import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { eps } from './url.service'
import {
  IncomingContractorPayroll,
  IncomingPayrollBatch,
  IncomingRunningPayrollBatch,
  RecalculatePayrollRequest,
  RunningPayrollBatch
} from '../store/contractor-payroll/contractor-payroll.state'
import { Observable } from 'rxjs'
import { PayoutFrequency } from '../store/payout-agreement/payout-agreement.state'

@Injectable({
  providedIn: 'root'
})
export class ContractorPayrollService {
  http = inject(HttpClient)
  api = eps.hrm.manageContractorPayrollApi
  payrollApi = eps.hrm.runContractorPayrollApi

  loadBatches(
    belongsTo: string,
    payoutFrequency: string,
    payPeriodStart: string,
    payPeriodEnd: string
  ) {
    return this.http.get<IncomingPayrollBatch[]>(this.api, {
      params: {
        belongsTo,
        payoutFrequency,
        payPeriodStart,
        payPeriodEnd
      }
    })
  }

  // Load running payroll batch
  loadRunningPayrollBatch(
    payPeriodStart: string,
    payPeriodEnd: string,
    belongsTo: string,
    payoutFrequency: PayoutFrequency
  ): Observable<IncomingRunningPayrollBatch> {
    return this.http.get<IncomingRunningPayrollBatch>(this.payrollApi, {
      params: { payPeriodStart, payPeriodEnd, businessId: belongsTo, payoutFrequency }
    })
  }

  recalculate(data: RecalculatePayrollRequest): Observable<IncomingContractorPayroll> {
    return this.http.post<IncomingContractorPayroll>(this.payrollApi + '/calculate-payroll', data)
  }

  upsertRunningPayrollBatch(
    batchData: RunningPayrollBatch
  ): Observable<IncomingRunningPayrollBatch> {
    return this.http.put<IncomingRunningPayrollBatch>(this.payrollApi, batchData)
  }

  updatePayrollStatus(data: {
    id: string
    status: string
    payrollIds: string[]
  }): Observable<IncomingRunningPayrollBatch> {
    return this.http.put<IncomingRunningPayrollBatch>(`${this.payrollApi}/status`, data)
  }

  deletePayrollBatch(id: string): Observable<{ id: string }> {
    return this.http.delete<{ id: string }>(`${this.payrollApi}/${id}`)
  }

  finalizePayrollBatch(
    batchId: string,
    dateOfPayment: string,
    modeOfPayment: string,
    paidBy: string
  ): Observable<IncomingPayrollBatch> {
    return this.http.put<IncomingPayrollBatch>(`${this.payrollApi}/finalize`, {
      batchId,
      dateOfPayment,
      modeOfPayment,
      paidBy
    })
  }
}
